import { useState } from 'react'
import { Button } from '../Button/Button'
import NavMenu from './NavMenu/NavMenu'
import logo from '../../assets/brand/logo.png'
import { useQuoteModal } from '../../context/QuoteContext'

const Header = () => {
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
	const { openQuoteModal } = useQuoteModal()

	return (
		<header className='sticky top-0 z-50 w-full bg-white/95 backdrop-blur-md shadow-sm border-b border-slate-100'>
			<div className='flex items-center justify-between px-4 py-2 sm:py-3 md:px-8 max-w-7xl mx-auto'>
				{/* 1. LOGO ALIGNED FAR LEFT (LARGER SCALE) */}
				<div className='flex items-center py-1'>
					<img
						src={logo}
						alt='Africa Pipetek Logo'
						className='h-12 sm:h-16 md:h-20 lg:h-24 w-auto object-contain transition-all'
					/>
				</div>

				{/* 2. MENU & BUTTON GROUPED TOGETHER ON THE FAR RIGHT */}
				<div className='hidden md:flex items-center gap-8 lg:gap-10'>
					<NavMenu />
					<Button
						size='md'
						className='font-heading text-base font-semibold shrink-0'
						onClick={openQuoteModal}>
						Request a Quote
					</Button>
				</div>

				{/* 3. MOBILE HAMBURGER BUTTON */}
				<button
					onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
					className='md:hidden p-2 rounded-lg text-slate-700 hover:bg-slate-100 focus:outline-none'
					aria-label='Toggle navigation menu'>
					{isMobileMenuOpen ? (
						<svg
							className='w-6 h-6'
							fill='none'
							stroke='currentColor'
							viewBox='0 0 24 24'>
							<path
								strokeLinecap='round'
								strokeLinejoin='round'
								strokeWidth='2'
								d='M6 18L18 6M6 6l12 12'
							/>
						</svg>
					) : (
						<svg
							className='w-6 h-6'
							fill='none'
							stroke='currentColor'
							viewBox='0 0 24 24'>
							<path
								strokeLinecap='round'
								strokeLinejoin='round'
								strokeWidth='2'
								d='M4 6h16M4 12h16M4 18h16'
							/>
						</svg>
					)}
				</button>
			</div>

			{/* MOBILE DRAWER */}
			{isMobileMenuOpen && (
				<div className='md:hidden bg-white border-b border-slate-200 px-6 py-6 flex flex-col gap-6 shadow-xl'>
					<NavMenu onLinkClick={() => setIsMobileMenuOpen(false)} />
					<Button
						fullWidth
						onClick={() => {
							setIsMobileMenuOpen(false)
							openQuoteModal()
						}}>
						Request a Quote
					</Button>
				</div>
			)}
		</header>
	)
}

export default Header
